// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M.608 6.577a.806.806 0 0 0-.544.427.828.828 0 0 0 .013.628c.055.112.91.976 5.556 5.618 5.134 5.13 5.502 5.492 5.659 5.572.261.133.42.172.708.172s.447-.039.708-.172c.157-.08.525-.443 5.659-5.572 4.795-4.79 5.498-5.503 5.552-5.618l.083-.174c.03-.057.029-.313-.002-.294-.013.008-.024-.005-.025-.029-.001-.142-.198-.393-.382-.487a.79.79 0 0 0-.685-.007c-.04.02-2.51 2.473-5.49 5.451L12 17.508l-5.418-5.416c-2.98-2.978-5.45-5.431-5.49-5.45a1.28 1.28 0 0 0-.355-.087 2.075 2.075 0 0 0-.129.022m-.6.743c0 .086.004.12.01.078a.763.763 0 0 0 0-.156c-.006-.043-.01-.008-.01.078"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ChevronBottomIcon = Icon;
export default ChevronBottomIcon;
